import { useRef } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_SAL2030_R01 } from "./Content_SAL2030_R01";
import { PdfView_SAL2030_R01 } from "./PdfView_SAL2030_R01";
import { SearchSection_SAL2030_R01 } from "./SearchSection_SAL2030_R01";
import { useSAL2030_R01Store } from "./Store_SAL2030_R01";
import { Table_SAL2030_R01 } from "./Table_SAL2030_R01";
import { AgGridReact } from "ag-grid-react";
import { SAL2030_R01Dto } from "./Dto_SAL2030_R01";


export const Container_SAL2030_R01 = () => {

	const { 
		initData,
		pdfUrl,
	} = useSAL2030_R01Store();

	const { setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'SAL2030_R01',
		type: 'width',
		storageKey: 'SAL2030_R01-split-width',
		min: 5,
		max: 80,
		default: 30
	} as const;

	const gridRef = useRef<AgGridReact<SAL2030_R01Dto>>(null);
	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	const { 
		splitValue,
		handleMouseDown,
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const {
		fetchData,
		fetchOne,
		handleExcelClick,
		handlePrintClick,
	} = Content_SAL2030_R01({
		gridRef,
		setMessage,
	});

	return <div className={`content-container`}>
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={undefined}
			onDeleteClick={undefined}
			onSaveClick={undefined}
			onPrintClick={handlePrintClick}
			onExcelClick={handleExcelClick}
			onInitClick={() => { initData(); } }
		/>
		<SearchSection_SAL2030_R01 />

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_SAL2030_R01 gridRef={gridRef} onRowClick={fetchOne} />
			</div>
			{/* 리사이저 */}
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이저"
			/>
			<div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<PdfView_SAL2030_R01 src={pdfUrl ?? undefined} />
			</div>
		</div>
		<Message />
	</div>
}
